import { render } from "./TasksView.vue?vue&type=template&id=190fab35"
import script from "./TasksView.vue?vue&type=script&lang=js"
export * from "./TasksView.vue?vue&type=script&lang=js"

import "./TasksView.vue?vue&type=style&index=0&id=190fab35&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__